import { i18nMark } from 'lingui-react';

const messages = {
  description: i18nMark('Service Requests'),
  title: i18nMark('Service Requests'),
  addNote: i18nMark('Add Note'),
  defaultHeader: i18nMark('Service Requests'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/ServiceRequestsPage/messages.js